import React, { useState } from 'react';

const LivestockTypeModal = ({ isOpen, onClose, onAddType, types }) => {
    const [typeName, setTypeName] = useState('');

    if (!isOpen) return null;
    
    const handleSubmit = (e) => {
        e.preventDefault();
        if (typeName.trim()) {
            onAddType(typeName.trim());
            setTypeName('');
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white rounded-lg shadow-xl p-8 w-full max-w-md m-4">
                <h2 className="text-2xl font-bold mb-6">Manage Livestock Types</h2>
                <ul className="space-y-2 mb-6 max-h-60 overflow-y-auto">
                    {types.map(type => <li key={type.id} className="p-2 bg-gray-100 rounded">{type.name}</li>)}
                </ul>
                <form onSubmit={handleSubmit}>
                    <label htmlFor="typeName" className="block text-sm font-medium text-gray-700">Add New Type</label>
                    <input id="typeName" value={typeName} onChange={e => setTypeName(e.target.value)} className="mt-1 block w-full p-2 border rounded" placeholder="e.g., Holstein Cow"/>
                    <div className="mt-6 flex justify-end space-x-3">
                        <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-200 rounded-md">Close</button>
                        <button type="submit" className="px-4 py-2 bg-indigo-600 text-white rounded-md">Add Type</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default LivestockTypeModal;